"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map